import { ColorPalette } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Витрина UI-кита для приёмки дизайна (ТЗ 14.2–14.3): все компоненты и состояния на RU и KK.
 * В разработке открывается без входа, в продакшене — только DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.ui-kit',
  area: 'backoffice',
  path: '/_kit',
  layout: 'fullscreen',
  devPublic: true,
  roles: ['DODOC_ADMIN'],
  icon: ColorPalette,
  titleKey: 'kit:title',
  navGroup: 'system',
  order: 900,
  load: () => import('./KitPage'),
});
